import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { IconButton } from '@atlaskit/button/new';
import ChevronDownIcon from '@atlaskit/icon/core/migration/chevron-down--hipchat-chevron-down';
import ChevronUpIcon from '@atlaskit/icon/core/migration/chevron-up--hipchat-chevron-up';
import CrossIcon from '@atlaskit/icon/core/migration/cross';
import { flagTextColorToken } from '../theme';
var DismissButtonComponent = function DismissButtonComponent(_ref) {
  var appearance = _ref.appearance,
    onClick = _ref.onClick,
    isBold = _ref.isBold,
    isExpanded = _ref.isExpanded,
    testId = _ref.testId;
  var ButtonIcon = CrossIcon;
  var buttonLabel = 'Dismiss';
  var size = 'small';
  var buttonTestId = testId && "".concat(testId, "-dismiss");
  if (isBold) {
    ButtonIcon = isExpanded ? ChevronUpIcon : ChevronDownIcon;
    buttonLabel = isExpanded ? 'Collapse' : 'Expand';
    size = 'medium';
    buttonTestId = testId && "".concat(testId, "-toggle");
  }
  return /*#__PURE__*/React.createElement(IconButton, {
    icon: function icon(iconProps) {
      return /*#__PURE__*/React.createElement(ButtonIcon, _extends({}, iconProps, {
        LEGACY_size: size,
        size: "small",
        label: "",
        color: flagTextColorToken[appearance]
      }));
    },
    appearance: "subtle",
    spacing: "compact",
    label: buttonLabel,
    onClick: onClick,
    "aria-expanded": isBold ? isExpanded : undefined,
    testId: buttonTestId
  });
};
var DismissButton = /*#__PURE__*/memo(DismissButtonComponent);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default DismissButton;